export const OWNER = "Sudheer Kumar";
export const BRAND = "Delhi Airport";
export const BRAND_FULL = "Delhi Airport Stay & Transit Services";
export const BRAND_SUB = "Stay & Transit Services";
export const TAGLINE = "IGI Airport's premier transit sanctuary — verified rooms, zero friction.";
export const PHONE_DISPLAY = "+91 83032 91675";
export const PHONE_DIGITS = "918303291675";
export const EMAIL = "sudheerkumar442551@gmail.com";
export const DISCLAIMER =
  "Whenever you have an inquiry, we will send actual room photos to you via chat. After you approve the photos, a 30% advance payment is required to confirm the booking.";

export const ROOMS = [
  { name: "Couple stay", price: "₹1,699", note: "6 hours only — not a full-night stay", tag: "Short stay", img: "/images/room-couple.webp" },
  { name: "Deluxe room · double occupancy", price: "₹1,999", note: "Full stay", tag: "Most requested", img: "/images/room-deluxe.webp", featured: true },
  { name: "Deluxe room · with breakfast", price: "₹2,625", note: "Full stay · breakfast as stated", tag: "Breakfast", img: "/images/room-deluxe.webp" },
  { name: "Triple occupancy", price: "₹2,999", note: "Full stay", tag: "Room", img: "/images/room-triple.webp" },
  { name: "Triple occupancy · with breakfast", price: "₹3,599", note: "Full stay · breakfast as stated", tag: "Breakfast", img: "/images/room-triple.webp" },
];

export const TRANSFERS = [
  { type: "Sedan", pickup: "₹899", drop: "₹799", detail: "Pickup + parking charges" },
  { type: "XL taxi", pickup: "₹1,099", drop: "₹999", detail: "Pickup + parking charges" },
];

export const AREAS = ["IGI Airport", "Yashobhoomi Convention Centre", "Kapashera Border"];

export function buildMessage(form) {
  return `Hello ${OWNER}, I would like to enquire about a booking.\n\nGuest: ${form.name}\nMobile/WhatsApp: ${form.mobile}\nCheck-in: ${form.checkIn || "Not provided"}\nCheck-out / 6-hour slot: ${form.checkOut || "Not provided"}\nGuests: ${form.guests}\nRoom/package: ${form.room}\nHotel/area preference: ${form.area || "Not specified"}\nBreakfast required: ${form.breakfast}\nAirport transfer: ${form.transfer === "Yes" ? `${form.vehicle}, ${form.transferType}` : "No"}\nSpecial request: ${form.special || "None"}\n\nI understand this is an enquiry subject to availability and final confirmation.`;
}
